<template>
  <div class="slots">
    <van-popup v-model="showPop" round :style="{width:'80%'}" :close-on-click-overlay="false" get-container="body">
      <div class="content">
        <van-form 
          :show-error-message="false" 
          validate-trigger="onSubmit" 
          validate-first
          input-align="right"
          ref="form"
          class="form"
        >
          <van-field 
            required 
            label="过渡背景"
            v-model="dialoguePage.dialogueBackImg"
            :rules="[{ required: true, message: '请上传过渡背景' }]"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="dialoguePage.dialogueBackImgArr" 
                :after-read="(e) => uploadImg(e, 'dialogueBackImg')"
                @delete="(e) => deleteImg('dialogueBackImg')"
              />
            </template>
          </van-field>
          <van-field 
            required 
            label="对话A"
            v-model="dialoguePage.dialogueAImg"
            :rules="[{ required: true, message: '请上传对话A' }]"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="dialoguePage.dialogueAImgArr" 
                :after-read="(e) => uploadImg(e, 'dialogueAImg')"
                @delete="(e) => deleteImg('dialogueAImg')"
              />
            </template>
          </van-field>
          <van-field 
            required 
            label="对话B"
            v-model="dialoguePage.dialogueBImg"
            :rules="[{ required: true, message: '请上传对话B' }]"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="dialoguePage.dialogueBImgArr" 
                :after-read="(e) => uploadImg(e, 'dialogueBImg')"
                @delete="(e) => deleteImg('dialogueBImg')"
              />
            </template>
          </van-field>
        </van-form>
        <div class="footer">
          <div class="button cancel" @click="cancel">取消</div>
          <div class="button" @click="submit">保存</div>
        </div>
         <div style="height:66px"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    isAddTransition: {
      type: Boolean,
      default: false
    },
    dialoguePage: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    showPop: {
      get() {
        return this.isAddTransition
      },
      set(val) {
        this.$emit('update:isAddTransition', val)
      }
    },
    from() {
      return this.$route.query.from
    }
  },
  data() {
    return {
      isUploadImg: false,
      headImgList: [],
    }
  },
  
  methods: {
    onCancel() {
      this.isPicker = false
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }
      return true;
    },
    uploadImg(e, field) {
      this.uploadImgFn(e, field)
    },
    uploadImgFn(e, field) {
      this.isUploadImg = true
      const currentFile = {
        url: '',
        status:'uploading',
        message: '上传中...'
      }
      this.dialoguePage[`${field}Arr`].push(currentFile)
      this.$api.common.uploadImg(e.file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            currentFile.url = fileUrl
            this.dialoguePage[field] = fileUrl
            currentFile.status = 'done'
            delete this.dialoguePage[field][0].status
            delete this.dialoguePage[field][0].message
            this.isUploadImg = false
          }
        })
        .catch(err => {
          this.dialoguePage[field] = []
          this.dialoguePage[`${field}Arr`] = ''
      });
    },
    deleteImg(field) {
      this.dialoguePage[field] = ''
      this.dialoguePage[`${field}Arr`] = []
    },
   
    submit() {
      // 图片上传中
      if (this.isUploadImg) return
        this.$refs.form.validate().then(async res => {
          if (this.from == 'manager') {
            const {activityId,id=''} = this.dialoguePage
            await this.$api.typeTest.saveStylePage({
              id,
              activityId,
              pageType: 'dialogue',
              pageMap:this.dialoguePage
            })
          }
          this.$emit('dialoguePageSaveSuccess', this.dialoguePage)
          this.$toast('保存成功');
          this.showPop = false
        }).catch(err => {
          this.$toast(err[0].message);
        })
    },
    cancel() {
      this.showPop = false
    },
  },
  mounted() {
  },
}
</script>

<style lang="stylus" scoped>
.content {
  .tips {
    font-size: 10px;
    color: #bbb;
    margin: 6px 0 6px 10px;
  }
  .serial-no {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #606266;
    font-weight: 600;
    height: 30px;
    margin: 0 15px;
    .replace {
      color: #ff6b31;
    }
  }
  .footer {
    box-sizing: border-box
    position absolute;
    left 0
    bottom 0
    height 60px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    border-bottom-left-radius: 16px
    border-bottom-right-radius: 16px
    background-color #fff;
    .button {
      padding 10px 40px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    }
    .cancel {
      color $mainTextColor
      background: #fff;
    }
  }
  .h5-cropper {
    position: absolute;
    left: -1000px;
    background: red;
  }
}
</style>